{
  "#OFFENE_POSTEN": {
    "TITLE": "Offene Posten",
    "DEBITOREN_TITLE": "Offene Posten Debitoren",
    "KREDITOREN_TITLE": "Offene Posten Kreditoren",
    "SUB_TITLE": "Aufgliederung nach Kalenderwoche",
    "EMPTY": "Keine offenen Posten",
    "DEBITOREN_SUB_TITLE": "Aufgliederung nach Kalenderwoche",
    "KREDITOREN_SUB_TITLE": "Aufgliederung nach Kalenderwoche",
    "LIST": "Liste",
    "PAGES": {
      "LIST": {
        "FAELLIGKEITSDATUM": "Fälligkeitsdatum",
        "RECHNUNGSNUMMER": "RechnungsNr.",
        "BELEGDATUM": "Belegdatum",
        "SYMBOL": "Symbol",
        "BETRAG": "Betrag",
        "SKONTO": "Skonto",
        "BATRAG_ABZGL_SKONTO": "Betrag abzgl. Skonto",
        "GESAMT": "Gesamt"
      }
    },
    "TABS": {
      "DIAGRAM": "Diagramm",
      "TABLE": "Tabelle"
    },
    "DIAGRAMM": {
      "LABEL_FAELLIGKEITEN": "Fälligkeiten",
      "LABEL_GUTSCHRIFTEN": "Gutschriften",
      "LABEL_ALLE_PER_HEUTE": "Alle per heute",
      "LABEL_DERZEITIGE_KW": "Restliche KW",
      "LABEL_NAECHSTE_KW": "Nächste KW",
      "LABEL_SPAETER": "Später"
    },
    "TABLE": {
      "HEADER": {
        "FAELLIGKEIT": "Fälligkeit",
        "NUMMER": "RE-Nr.",
        "BELEGDATUM": "Belegdatum",
        "SYMBOL": "Symbol",
        "SALDO": "Betrag",
        "SKONTO": "Skonto",
        "KUNDE": "Kunde",
        "SALDO_ABZGL_SKONTO": "Betrag abzgl. Skonto",
        "DOWNLOAD": "Herunterladen"
      }
    }
  }
}
